
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["navigate"],
  props: ["row", "cols", "headings"],
});
